<template>
  <div
    class="V_img_sect_title"
    :class="{ 'video-play-icon': post.format === 4 }"
  >
    <a :href="post.postUrl">
      <div class="containerVideoImage img-wrap">
        <img
          :src="post.principalImage.url"
          :alt="post.principalImage.alt"
          :title="post.principalImage.title"
        />
      </div>
    </a>
    <div v-if="post.videoShow" class="program">
      <a :href="post.videoShowUrl" v-html="post.videoShow"></a>
    </div>
    <div class="kicker" v-bind:class="post.section.className">
      <span v-html="post.header"></span>
    </div>
    <h2 class="tt">
      <a
        :href="post.postUrl"
        v-bind:class="post.section.className"
        v-html="post.title"
      ></a>
    </h2>
  </div>
</template>

<script>
export default {
  props: {
    post: Object,
    groupName: String,
  },
};
</script>
